import ItemType from '../enums/ItemType';
import Offer from './contracts/Offer';
import Item from './contracts/Item';

export default class ItemImpl implements Item{

    private id: string | number = "";
    private title: string = "";
    private url: string | null = null;
    private posterUrl: string | null = null;
    private releaseYear: number | null = null;
    private type: ItemType = ItemType.Unknown;
    private offers:Array<Offer> = [];
    private rtScore: number | null = null;
    private imdbScore: number | null = null;
    private jwScore: number | null = null;
    private tmdbScore: number | null = null;

    /**
     * Getter $id
     * @return {string | number }
     */
	public getId(): string | number  {
		return this.id;
	}

    /**
     * Getter $title
     * @return {string}
     */
	public getTitle(): string {
		return this.title;
	}

    /**
     * Getter $url
     * @return {string}
     */
    getUrl(): string | null {
        return this.url;
    }

    /**
     * Getter $posterUrl
     * @return {string}
     */
	public getPosterUrl(): string | null {
		return this.posterUrl;
	}

    /**
     * Getter $releaseYear
     * @return {number}
     */
	public getReleaseYear(): number | null {
		return this.releaseYear;
	}

    /**
     * Getter $type
     * @return {ItemType}
     */
	public getType(): ItemType {
		return this.type;
	}

    /**
     * Getter $offers
     * @return {Array<Offer>}
     */
	public getOffers(): Array<Offer> {
		return this.offers;
	}

    /**
     * Getter $rtScore
     * @return {number}
     */
	public getRtScore(): number | null {
		return this.rtScore;
	}

    /**
     * Getter $imdbScore
     * @return {number}
     */
	public getImdbScore(): number | null {
		return this.imdbScore;
	}

    /**
     * Getter $jwScore
     * @return {number}
     */
	public getJwScore(): number | null {
		return this.jwScore;
	}

    /**
     * Getter $tmdbScore
     * @return {number}
     */
	public getTmdbScore(): number | null {
		return this.tmdbScore;
	}

    /**
     * Setter $id
     * @param {string } value
     */
	public setId(value: string ):Item {
        this.id = value;
        return this;
	}

    /**
     * Setter $title
     * @param {string} value
     */
	public setTitle(value: string):Item {
        this.title = value;
        return this;
	}

    /**
     * Setter $url
     * @param {string} value
     */
    setUrl(value: string | null): Item {
        this.url = value;
        return this;
    }

    /**
     * Setter $posterUrl
     * @param {string} value
     */
	public setPosterUrl(value: string):Item  {
        this.posterUrl = value;
        return this;
	}

    /**
     * Setter $releaseYear
     * @param {number} value
     */
	public setReleaseYear(value: number):Item  {
        this.releaseYear = value;
        return this;
	}

    /**
     * Setter $type
     * @param {ItemType} value
     */
	public setType(value: ItemType):Item  {
        this.type = value;
        return this;
	}

    /**
     * Setter $offers
     * @param {Array<Offer>} value
     */
	public setOffers(value: Array<Offer>):Item  {
        this.offers = value;
        return this;
	}

    /**
     * Setter $rtScore
     * @param {number} value
     */
	public setRtScore(value: number):Item  {
        this.rtScore = value;
        return this;
	}

    /**
     * Setter $imdbScore
     * @param {number} value
     */
	public setImdbScore(value: number):Item  {
        this.imdbScore = value;
        return this;
	}

    /**
     * Setter $jwScore
     * @param {number} value
     */
	public setJwScore(value: number):Item  {
        this.jwScore = value;
        return this;
	}

    /**
     * Setter $tmdbScore
     * @param {number} value
     */
	public setTmdbScore(value: number):Item  {
        this.tmdbScore = value;
        return this;
	}
}